import { operatorService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    current: {},
    selectList: {},
    loading: false
  }
}

export const operators = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllOperators({ commit }, params) {
      commit('getAllOperatorsRequest');
      operatorService.getAll(params)
      .then(
          operators => commit('getAllOperatorsSuccess', operators),
          error => commit('getAllOperatorsFailure', error)
      );
    },
    getSelectList({ commit }) {
      commit('getSelectListRequest');
      operatorService.getSelectList()
      .then(
          operators => commit('getSelectListSuccess', operators),
          error => commit('getSelectListFailure', error)
      );
    },
    getById({ commit }, operatorId) {
      commit('getByIdRequest');
      operatorService.getById(operatorId)
      .then(
          operator => commit('getByIdSuccess', operator),
          error => commit('getByIdFailure', error)
      );
    },
    addOperator({ commit }, payload){
      commit('addOperatorRequest');
      operatorService.addOperator(payload)
      .then(
        operators => commit('addOperatorSuccess', operators),
        error => commit('addOperatorFailure', error)
      )
    },
    updateOperator({ commit }, payload){
      commit('updateOperatorRequest');
      operatorService.updateOperator(payload)
      .then(
        operators => commit('updateOperatorSuccess', operators),
        error => commit('updateOperatorFailure', error)
      )
    },
    deleteOperator({ commit }, payload){
      commit('deleteOperatorRequest');
      operatorService.deleteOperator(payload)
      .then(
        commit('deleteOperatorSuccess'),
        error => commit('deleteOperatorFailure', error)
      )
      return true;
    },
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllOperatorsRequest(state) {
        state.loading = true;
    },
    getAllOperatorsSuccess(state, operators) {
        state.all = Object.values(operators);
        state.loading = false;
    },
    getAllOperatorsFailure(state, error) {
        state.all = { error };
        state.loading = false;
    },
    getSelectListRequest(state) {
        state.selectList = { loading: true };
    },
    getSelectListSuccess(state, operators) {
        state.selectList = Object.values(operators);
    },
    getSelectListFailure(state, error) {
        state.selectList = { error };
    },
    getByIdRequest(state) {
        state.current = { loading: true };
    },
    getByIdSuccess(state, operator) {
        state.current = operator;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addOperatorRequest(state, operator) {
        state.current = operator
    },
    addOperatorSuccess(state, operator) {
      //if(operator.id == state.current.operator.id){
        state.current = operator;
      //}
    },
    updateOperatorRequest(state, operator) {
      state.current = operator
    },
    updateOperatorSuccess(state, operator) {
      if(operator.id == state.current.operator.id){
        state.current = operator;
      }
    },
    addOperatorFailure(state, error) {
      state.update = { error };
    },
    deleteOperatorRequest(state, operator) {
      state.current = operator
    },
    deleteOperatorSuccess(state) {
        state.current = {};
        return true;
    },
    deleteOperatorFailure(state, error) {
      state.update = { error };
    }
  }
}